import styled from 'styled-components';

export default styled.p`
  margin: 0 4px 0;
  color: #ff4f4f;
  font-family: var(--google-sora-cdn);
  font-size: 12px;
  line-height: 16px;
`;
